<li class="non-runners" *ngIf="nonRunners.length">
    <span class="caption-text">{{ messages.NonRunners }}</span>
    <span class="value-text">
        <span *ngFor="let participant of nonRunners; let last = last">
            <b>{{ participant.raceCardNumber }}</b
            >&nbsp;{{ participant.name }}<ng-container *ngIf="!last">, </ng-container>
        </span>
    </span>
</li>
